import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=5217e6f1&"
import script from "./CheckboxInput.vue?vue&type=script&lang=js&"
export * from "./CheckboxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5217e6f1')) {
      api.createRecord('5217e6f1', component.options)
    } else {
      api.reload('5217e6f1', component.options)
    }
    module.hot.accept("./CheckboxInput.vue?vue&type=template&id=5217e6f1&", function () {
      api.rerender('5217e6f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/CheckboxInput.vue"
export default component.exports